﻿import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";
import { enqueueSnackbar } from "notistack";
import type { MutationDeleteEnergyDealArgs } from "@/types/graphql";

/**
 * Custom hook to delete a deal.
 * @param {Function} [onCompleted] - Callback function to be called when the mutation completes successfully.
 * @param {Function} [onError] - Callback function to be called when an error occurs during the mutation.
 * @returns {{delete: Function, deleting: boolean}} - The function to delete a deal and the loading state.
 */
export function useDeleteDeal(onCompleted = () => {}, onError = () => {}) {
  const [deleteDeal, { loading }] = useMutation<any>(mutations.deleteDeal, {
    onCompleted,
    onError: (err) => {
      (onError as any)(err);

      enqueueSnackbar(err.message, {
        variant: "error",
      });
    },
    refetchQueries: ["GetAllDeals"],
    errorPolicy: "all",
  });

  const deleteDealRow = useCallback(
    (variables: MutationDeleteEnergyDealArgs) => {
      deleteDeal({
        variables,
      }).then();
    },
    [deleteDeal],
  );

  return {
    delete: deleteDealRow,
    deleting: loading,
  };
}
